import { jsx } from 'react/jsx-runtime';
import { createContext, useContext, useState, useCallback, useEffect } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign$1 = function() {
    __assign$1 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};

function __awaiter$1(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator$1(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var debug = console.debug, info = console.info, warn = console.warn, error = console.error;
var defaultLogger = { debug: debug, info: info, warn: warn, error: error };

var endpoints = {
    evaluate: "/api/featureflag/evaluation/flag",
    evaluateBulk: "/api/featureflag/evaluation/bulk",
};
var fetch = typeof window !== "undefined" ? window.fetch : require("node-fetch");
var FeatureFlagClient = /** @class */ (function () {
    function FeatureFlagClient(config) {
        var _a;
        var host = new URL(config.apiOrigin);
        if (!host.protocol.match(/^https?:$/)) {
            throw new Error("http or https protocol must be used for bread API calls");
        }
        this.origin = host.origin;
        this.logger = (_a = config.logger) !== null && _a !== void 0 ? _a : defaultLogger;
        this.clientSideId = config.clientSideId;
        this.evaluationContext = __assign({}, config.context);
    }
    /**
     * Evaluates a single flag and returns the result as a string.
     * Will reject if a network error is encountered and a finallyValue is not provided.
     * @param flagName - Name of feature flag to evaluate
     * @param [finallyValue] - Value to return if evaluation produces no results
     * @returns flag evaluation result on successful eval.  otherwise returns either the provided finallyValue or null.
     */
    FeatureFlagClient.prototype.evaluate = function (flagName, finallyValue) {
        return __awaiter(this, void 0, void 0, function () {
            var result, response, json, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        result = finallyValue !== null && finallyValue !== void 0 ? finallyValue : null;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        return [4 /*yield*/, fetch("".concat(this.origin).concat(endpoints.evaluate, "/").concat(flagName), {
                                method: "POST",
                                content: "application/json",
                                body: JSON.stringify(this.evaluationContext),
                                headers: {
                                    accept: "application/json",
                                },
                            })];
                    case 2:
                        response = _a.sent();
                        return [4 /*yield*/, response.json()];
                    case 3:
                        json = _a.sent();
                        if (response.status === 200) {
                            result = json === null || json === void 0 ? void 0 : json.result;
                        }
                        else if (response.status === 204) {
                            this.logger.info("Flag name: ".concat(flagName, " is disabled."));
                        }
                        else if (response.status === 400) {
                            this.logger.error("Flag name: ".concat(flagName, " did not return a result with the provided context. body: ").concat(JSON.stringify(json)));
                        }
                        else if (response.status === 404) {
                            this.logger.error("Flag name: ".concat(flagName, " could not be found!  body: ").concat(JSON.stringify(json)));
                        }
                        else if (response.status === 410) {
                            this.logger.error("Flag name: ".concat(flagName, " has been deleted!   body: ").concat(JSON.stringify(json)));
                        }
                        else {
                            this.logger.error("Unexpected Error Response received from feature flag service\nResponse status: ".concat(response.status, "\nResponse Body: ").concat(JSON.stringify(json)));
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        e_1 = _a.sent();
                        this.logger.error("Unexpected Error occurred while evaluating feature flag: ", flagName, "\n", e_1.toString());
                        return [2 /*return*/, finallyValue ? Promise.resolve(result) : Promise.reject(e_1)];
                    case 5: return [2 /*return*/, Promise.resolve(result)];
                }
            });
        });
    };
    /**
     * Evaluates all flags with the given context that are linked with the provided tag
     * @param options - filter params.  Currently only supports a required filter on `tag`
     * @returns map of flag name : FlagResponse if evaluation was successful and returned results, otherwise returns an empty object
     */
    FeatureFlagClient.prototype.bulkEvaluate = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            var tag, params, response, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        tag = options.tag;
                        if (!tag) {
                            return [2 /*return*/, Promise.reject("Tag name is required")];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        params = new URLSearchParams();
                        if (tag) {
                            params.set("tag", tag);
                        }
                        return [4 /*yield*/, fetch("".concat(this.origin).concat(endpoints.evaluateBulk, "?").concat(params.toString()), {
                                method: "POST",
                                body: JSON.stringify(this.evaluationContext),
                            })];
                    case 2:
                        response = _a.sent();
                        if (response.status === 200) {
                            return [2 /*return*/, response.json()];
                        }
                        if (response.status === 400) {
                            this.logger.error("Bad request, bulk evaluation was unsuccessful due to: ".concat(response.statusText));
                        }
                        else if (response.status === 404) {
                            this.logger.error("Requested tag ".concat(tag, " was not found"));
                        }
                        else {
                            this.logger.error("Unexpected response received from bulk evaluation", response.status, "\nstatus text:", response.statusText);
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        this.logger.error("Unexpected Error occurred during bulk evaluation", e_2.toString());
                        return [2 /*return*/, Promise.reject(e_2)];
                    case 4: return [2 /*return*/, Promise.resolve({})];
                }
            });
        });
    };
    return FeatureFlagClient;
}());

var camelcase$1 = {exports: {}};

const UPPERCASE = /[\p{Lu}]/u;
const LOWERCASE = /[\p{Ll}]/u;
const LEADING_CAPITAL = /^[\p{Lu}](?![\p{Lu}])/gu;
const IDENTIFIER = /([\p{Alpha}\p{N}_]|$)/u;
const SEPARATORS = /[_.\- ]+/;

const LEADING_SEPARATORS = new RegExp('^' + SEPARATORS.source);
const SEPARATORS_AND_IDENTIFIER = new RegExp(SEPARATORS.source + IDENTIFIER.source, 'gu');
const NUMBERS_AND_IDENTIFIER = new RegExp('\\d+' + IDENTIFIER.source, 'gu');

const preserveCamelCase = (string, toLowerCase, toUpperCase) => {
	let isLastCharLower = false;
	let isLastCharUpper = false;
	let isLastLastCharUpper = false;

	for (let i = 0; i < string.length; i++) {
		const character = string[i];

		if (isLastCharLower && UPPERCASE.test(character)) {
			string = string.slice(0, i) + '-' + string.slice(i);
			isLastCharLower = false;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = true;
			i++;
		} else if (isLastCharUpper && isLastLastCharUpper && LOWERCASE.test(character)) {
			string = string.slice(0, i - 1) + '-' + string.slice(i - 1);
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = false;
			isLastCharLower = true;
		} else {
			isLastCharLower = toLowerCase(character) === character && toUpperCase(character) !== character;
			isLastLastCharUpper = isLastCharUpper;
			isLastCharUpper = toUpperCase(character) === character && toLowerCase(character) !== character;
		}
	}

	return string;
};

const preserveConsecutiveUppercase = (input, toLowerCase) => {
	LEADING_CAPITAL.lastIndex = 0;

	return input.replace(LEADING_CAPITAL, m1 => toLowerCase(m1));
};

const postProcess = (input, toUpperCase) => {
	SEPARATORS_AND_IDENTIFIER.lastIndex = 0;
	NUMBERS_AND_IDENTIFIER.lastIndex = 0;

	return input.replace(SEPARATORS_AND_IDENTIFIER, (_, identifier) => toUpperCase(identifier))
		.replace(NUMBERS_AND_IDENTIFIER, m => toUpperCase(m));
};

const camelCase = (input, options) => {
	if (!(typeof input === 'string' || Array.isArray(input))) {
		throw new TypeError('Expected the input to be `string | string[]`');
	}

	options = {
		pascalCase: false,
		preserveConsecutiveUppercase: false,
		...options
	};

	if (Array.isArray(input)) {
		input = input.map(x => x.trim())
			.filter(x => x.length)
			.join('-');
	} else {
		input = input.trim();
	}

	if (input.length === 0) {
		return '';
	}

	const toLowerCase = options.locale === false ?
		string => string.toLowerCase() :
		string => string.toLocaleLowerCase(options.locale);
	const toUpperCase = options.locale === false ?
		string => string.toUpperCase() :
		string => string.toLocaleUpperCase(options.locale);

	if (input.length === 1) {
		return options.pascalCase ? toUpperCase(input) : toLowerCase(input);
	}

	const hasUpperCase = input !== toLowerCase(input);

	if (hasUpperCase) {
		input = preserveCamelCase(input, toLowerCase, toUpperCase);
	}

	input = input.replace(LEADING_SEPARATORS, '');

	if (options.preserveConsecutiveUppercase) {
		input = preserveConsecutiveUppercase(input, toLowerCase);
	} else {
		input = toLowerCase(input);
	}

	if (options.pascalCase) {
		input = toUpperCase(input.charAt(0)) + input.slice(1);
	}

	return postProcess(input, toUpperCase);
};

camelcase$1.exports = camelCase;
// TODO: Remove this for the next major release
camelcase$1.exports.default = camelCase;

var camelcase = camelcase$1.exports;

/**
 * Simplifies the response object into something easy to consume on the frontend.  Keys are converted to camelcase,
 * and result object reduced to just the string result.
 * @param flags - Flags from API
 * @param logger - logger client implementation for duplicate key errors
 */
var flattenFlagResponse = function (flags, logger) {
    var updatedRecords = {};
    Object.entries(flags).forEach(function (_a) {
        var key = _a[0], value = _a[1];
        var updatedKey = camelcase(key);
        if (updatedRecords[updatedKey]) {
            logger.error("Duplicate camelcase tag name found: [".concat(updatedKey, "] is already defined, secondary result(s) are ignored"));
        }
        updatedRecords[updatedKey] = value.result;
    });
    return updatedRecords;
};
// retrieve flags with a given tag, if an error is thrown return an empty object
var fetchFlags = function (client, tag, logger) { return __awaiter$1(void 0, void 0, void 0, function () {
    var rawFlags, e_1;
    return __generator$1(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, client.bulkEvaluate({
                        tag: tag,
                    })];
            case 1:
                rawFlags = _a.sent();
                return [2 /*return*/, flattenFlagResponse(rawFlags, logger)];
            case 2:
                e_1 = _a.sent();
                logger.error("Error thrown fetching flags: ".concat(e_1));
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/, {}];
        }
    });
}); };
var createConsoleLogger = function () {
    var debug = console.debug, info = console.info, warn = console.warn, error = console.error;
    return { debug: debug, info: info, warn: warn, error: error };
};

var FFContext = createContext({ flags: {}, client: null, loading: true });
/**
 * Get all flags available within current context
 */
var useFeatureFlags = function () {
    var flags = useContext(FFContext).flags;
    return flags;
};
var useFFClient = function () {
    var client = useContext(FFContext).client;
    return client;
};
var useFeatureFlagContext = function () {
    var context = useContext(FFContext);
    if (!context) {
        throw new Error("useFeatureFlagContext can only be used within a provider that implements FFContext");
    }
    return context;
};

function asyncWithFFProvider(config) {
    return __awaiter$1(this, void 0, void 0, function () {
        var apiOrigin, clientSideId, tag, context, logger, loggerImpl, client, flags, FFProvider;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    apiOrigin = config.apiOrigin, clientSideId = config.clientSideId, tag = config.tag, context = config.context, logger = config.logger;
                    loggerImpl = logger !== null && logger !== void 0 ? logger : createConsoleLogger();
                    client = new FeatureFlagClient({ apiOrigin: apiOrigin, clientSideId: clientSideId, context: context, logger: loggerImpl });
                    return [4 /*yield*/, fetchFlags(client, tag, loggerImpl)];
                case 1:
                    flags = _a.sent();
                    FFProvider = function (_a) {
                        var children = _a.children;
                        var ffData = useState({
                            flags: flags,
                            client: client,
                            // a note here: because of the way the provider was implemented, the value of
                            // "loading" will always be false, because the flags are fetched prior to provider
                            // creation.
                            loading: false,
                        })[0];
                        // useEffect(() => {
                        // 	// client.on("change", () => {
                        // 	// 	// todo update flag cache once streaming events implemented (iteration 2)
                        // 	// });
                        // }, []);
                        return jsx(FFContext.Provider, __assign$1({ value: ffData }, { children: children }));
                    };
                    return [2 /*return*/, FFProvider];
            }
        });
    });
}

function FeatureFlagProvider(_a) {
    var _this = this;
    var apiOrigin = _a.apiOrigin, clientSideId = _a.clientSideId, tag = _a.tag, context = _a.context, _b = _a.logger, logger = _b === void 0 ? createConsoleLogger() : _b, children = _a.children;
    var _c = useState({
        flags: {},
        client: null,
        loading: true,
    }), ffData = _c[0], setFFData = _c[1];
    var updateFFData = useCallback(function () { return __awaiter$1(_this, void 0, void 0, function () {
        var client_1, flags_1, e_1;
        return __generator$1(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    client_1 = new FeatureFlagClient({ apiOrigin: apiOrigin, clientSideId: clientSideId, context: context, logger: logger });
                    return [4 /*yield*/, fetchFlags(client_1, tag, logger)];
                case 1:
                    flags_1 = _a.sent();
                    setFFData(function (prev) { return (__assign$1(__assign$1({}, prev), { loading: false, client: client_1, flags: flags_1 })); });
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _a.sent();
                    logger.error("".concat(e_1));
                    // we already handle error logging, but now we just need to
                    // ensure that loading is set to false.
                    setFFData(function (prev) { return (__assign$1(__assign$1({}, prev), { loading: false })); });
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [apiOrigin, clientSideId, context, logger, tag]);
    useEffect(function () {
        updateFFData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return jsx(FFContext.Provider, __assign$1({ value: ffData }, { children: children }));
}

var defaultReactOptions = { useCamelCaseFlagKeys: true };

export { FFContext, FeatureFlagProvider, asyncWithFFProvider, defaultReactOptions, useFFClient, useFeatureFlagContext, useFeatureFlags };
//# sourceMappingURL=index.mjs.map
